export enum TemplateEntityType {
    template = 1,
    category = 2,
}
